// extracted by mini-css-extract-plugin
export default {"wrap":"Spinner_wrap__uD8dd","spinner":"Spinner_spinner__JgyQe","spin":"Spinner_spin__pROWi"};